import React, { Component } from "react";
import * as d3 from "d3";
import {
  getInitialSVG,
  setSVGDefs,
  setSVGEvents,
  getInitialDrag,
  getInitialForce,
  getTranslateString,
  setDefsGradient,
} from "./roadmapCreator/helperFunctions";
import { loadingGif } from "./roadmapCreator/svgs";
import {
  fetchRoadmap,
  fetchUser,
  onTrackRoadmap,
  onUntrackRoadmap,
  updateTrackingRoadmap,
  updateClearItem,
} from "../stitch";
import { app as mongoDB } from "../stitch";
import CreatorCardStyles from "../styles";
import Navbar from "./Navbar.jsx";
import Skeleton from "react-loading-skeleton";
import { useStitchAuth, StitchAuthContext } from "../StitchAuth.js";
import { ModalContext } from "../App.js";
import { checkmark } from "./roadmapCreator/svgs";
import * as Realm from "realm-web";

const background = "blue";
class RoadmapReader extends Component {
  constructor(props) {
    super(props);

    this.links = [];
    this.nodes = [];
    this.state = {
      isRoadmapLoading: true,
      creatorData: null,
      isTrackRequestReceived: true,
      errorMessages: [],
      hasNewNoteSavingRequested: false,
      isNewNoteSaving: false,
      isClearMode: false,
      editionIndex: null,
    };

    this.svg = null;
    this.container = null;
    this.path = null;
    this.rectGroups = null;
    this.circleGroups = null;
    this.texts = null;
    this.force = null;
    this.drag = null;
    this.dragLine = null;

    this.history = [{ nodes: [], links: [] }];
    this.historyStep = 0;

    this.trackViewUIWrapperRef = React.createRef();
    this.publicViewUIWrapperRef = React.createRef();

    this.selectedNode = null;
  }

  componentDidMount() {
    var path = this.props.history.location.pathname;
    var roadmapID = path.substring(path.indexOf("/roadmap/") + 9);

    fetchRoadmap(roadmapID)
      .then((roadmap) => {
        var creatorId = roadmap.creatorId;
        console.log({ roadmap });
        console.log("custom data", mongoDB.currentUser.customData);
        //custom data is refreshed in fetchRoadmap

        if (
          roadmap.roadmapDataHistory.length === 1 &&
          roadmap.roadmapDataHistory[0].type === "draft"
        ) {
          alert("roadmap 404 or permission denied");
          this.props.history.push("/");
        }

        fetchUser(creatorId)
          .then((userData) => {
            this.setState({ creatorData: userData });
          })
          .catch((err) => {
            console.log(err);
          });

        var isTracking =
          mongoDB.currentUser.providerType !== "anon-user" &&
          mongoDB.currentUser.customData.starredRoadmaps.some(
            (roadmap) => roadmap.roadmapId.$oid === roadmapID
          );

        this.setState({
          isTracking: isTracking,
          isTrackingUI: isTracking,
        });
        if (isTracking) {
          //TODO:
          //note, this is the public roadmap, roadmapData always the latest
          //however, if our editionIndex ain't the same as the newest one,
          //display a message noting that
          fetchUser(mongoDB.currentUser.id).then((user1) => {
            const user = user1;

            const starredRoadmaps = user.starredRoadmaps;

            console.log({ starredRoadmaps });

            const starredRoadmap = starredRoadmaps.filter(
              (eachRoadmap) => eachRoadmap.roadmapId.toString() === roadmapID
            )[0];
            const {
              noteLinks,
              noteNodes,
              completedNodesID,
              editionIndex,
            } = starredRoadmap;

            setUpData(
              isTracking,
              noteLinks,
              noteNodes,
              completedNodesID,
              editionIndex,
              this
            );
          });
        } else {
          setUpData(
            isTracking,
            null,
            null,
            null,
            roadmap.roadmapDataHistory.length - 1,
            this
          );
        }

        function setUpData(
          isTracking,
          noteLinks,
          noteNodes,
          completedNodesID,
          editionIndex = roadmap.roadmapDataHistory.length - 1,
          that
        ) {
          console.log(
            "roadmap on setupdata",
            roadmap,
            roadmap.roadmapDataHistory.length - 1,
            editionIndex
          );
          const roadmapData = roadmap.roadmapDataHistory[editionIndex];
          that.setState({
            editionIndex: editionIndex,
            lastestIndex: roadmap.roadmapDataHistory.length - 1,
          });
          that.roadmapMacroData = roadmap;

          that.roadmapData = roadmapData;
          console.log("destructing", roadmapData);
          const {
            nodes,
            links,
            title,
            type,
            backgroundColor,
            category,
            description,
            font,
            date,
          } = roadmapData;

          if (isTracking) {
            console.log({ noteNodes });
            that.nodes = [...nodes, ...noteNodes];
            that.nodes = that.nodes.map((eachNode) => {
              if (completedNodesID.some((id) => eachNode.id === id)) {
                return { ...eachNode, isCleared: true };
              }
              return eachNode;
            });
            console.log(that.nodes);
          } else {
            that.nodes = nodes;
          }
          var cleanLinks;
          var cleanPublicLinks = links.map((eachLink) => {
            return {
              ...eachLink,
              source: eachLink.source.id,
              target: eachLink.target.id,
            };
          });
          if (isTracking) {
            cleanLinks = [...links, ...noteLinks].map((eachLink) => {
              return {
                ...eachLink,
                source: eachLink.source.id,
                target: eachLink.target.id,
              };
            });
          } else {
            cleanLinks = links.map((eachLink) => {
              return {
                ...eachLink,
                source: eachLink.source.id,
                target: eachLink.target.id,
              };
            });
          }

          that.publicNodes = [...nodes];
          that.publicLinks = [...cleanPublicLinks];

          that.links = cleanLinks;
          that.backgroundColor = backgroundColor;
          that.title = title;
          that.font = font;
          that.category = category;
          that.description = description;
          that.date = getFormattedDate(date);
          that.setState({ isRoadmapLoading: false });
          that.setUp();

          function getFormattedDate(date) {
            var year = date.getFullYear();

            var month = (1 + date.getMonth()).toString();
            month = month.length > 1 ? month : "0" + month;

            var day = date.getDate().toString();
            day = day.length > 1 ? day : "0" + day;

            return month + "-" + day + "-" + year;
          }
        }
      })
      .catch((err) => {
        alert(err);
        this.props.history.push("/");
      });
  }

  storeToHistory(command) {
    this.history = this.history.slice(0, this.historyStep + 1);
    this.history = this.history.concat([command]);
    this.historyStep += 1;

    this.setState({ isNewNoteSaving: true, hasNewNoteSavingRequested: true });
    // make async request to save note

    var notes = this.nodes.filter((node) => node.type === "note");
    var noteLinks = this.links.filter(
      (link) => link.source.type === "note" || link.target.type === "note"
    );
    var path = this.props.history.location.pathname;
    var roadmapID = path.substring(path.indexOf("/roadmap/") + 9);

    updateTrackingRoadmap({
      newNotes: notes,
      newNoteLinks: noteLinks,
      roadmapId: roadmapID,
    }).then((res) => {
      this.setState({ isNewNoteSaving: false });
    });
  }

  undo() {
    if (!this.state.isTracking || !this.state.isTrackingUI) {
      return;
    }

    if (this.historyStep !== 0) {
      var inverseCommand = this.history[this.historyStep].inverse;
      if (this.isFormShowing && !this.isTyping) {
        //this.setMessage("Please save form before undo", 2000);
        return;
      }
      switch (inverseCommand.type) {
        case "delNode":
          if (
            this.selectedNode &&
            this.selectedNode.id === inverseCommand.node.id
          ) {
            this.selectedNode = null;
          }
          this.nodes = this.nodes.filter(
            (n) => n.id !== inverseCommand.node.id
          );
          break;

        case "delLink":
          this.links = this.links.filter(
            (l) => l.index !== inverseCommand.link.index
          );
          if (
            this.selectedLink &&
            this.selectedLink.index === inverseCommand.link.index
          ) {
            this.selectedLink = null;
            this.restart();
            this.forceUpdate();
          }

          break;

        case "addLink":
          this.links.push({
            source: inverseCommand.link.source,
            target: inverseCommand.link.target,
            linkDistance: inverseCommand.link.linkDistance,
            index: inverseCommand.link.index,
          });

          break;

        case "delNodeLink":
          this.nodes = this.nodes.filter(
            (n) => n.id !== inverseCommand.node.id
          );
          this.links = this.links.filter((l) => {
            //if l.index is found in any link in inverseCommand.links, return false
            var keepLink = true;
            inverseCommand.links.map((eachCommandLink) => {
              if (eachCommandLink.index === l.index) {
                keepLink = false;
              }
            });
            return keepLink;
          });
          break;

        case "addNodeLink":
          this.nodes.push(inverseCommand.node);

          inverseCommand.links.map((eachLink) => {
            this.links.push({
              source: eachLink.source,
              target: eachLink.target,
              linkDistance: eachLink.linkDistance,
              index: eachLink.index,
            });
          });

          break;

        case "modifyText":
          this.nodes.map((n) => {
            if (n.id === inverseCommand.node.id) {
              console.log("old text", n.text, "new", inverseCommand.text);
              n.text = inverseCommand.text;
            }
          });
          break;

        case "modifyAttribute":
          var { object, attribute, attributeValue } = inverseCommand;
          object[attribute] = attributeValue;
          break;
      }
      this.historyStep -= 1;
    } else {
      this.setMessage("Nothing to Undo");
      return;
    }
    this.restart();
    this.forceUpdate();
  }

  redo() {
    if (!this.state.isTracking || !this.state.isTrackingUI) {
      return;
    }

    if (this.historyStep !== this.history.length - 1) {
      this.historyStep += 1;
      var actionCommand = this.history[this.historyStep].action;
      switch (actionCommand.type) {
        case "addNode":
          this.nodes.push(actionCommand.node);
          break;
        case "addLink":
          this.links.push({
            source: actionCommand.link.source,
            target: actionCommand.link.target,
            linkDistance: actionCommand.link.linkDistance,
            index: actionCommand.link.index,
          });
          break;
        case "delLink":
          this.links = this.links.filter(
            (l) => l.index !== actionCommand.link.index
          );
          break;

        case "modifyText":
          this.nodes.map((n) => {
            if (n.id === actionCommand.node.id) {
              n.text = actionCommand.text;
            }
          });

          break;

        case "modifyResourceNode":
          this.nodes.map((n) => {
            if (n.id === actionCommand.node.id) {
              this.setMessage("Node information updated");
              n.storedInfo = actionCommand.storedInfo;
              this.circleGroups.selectAll(".nodeImage").each(function (d) {
                if (d.id !== actionCommand.node.id) return;

                if (
                  !actionCommand.node.storedInfo.picture ||
                  actionCommand.node.storedInfo.picture === ""
                ) {
                  // if there's nothing appended, href null
                  d3.select(this).attr("href", null);
                } else {
                  d3.select(this).attr(
                    "href",
                    actionCommand.storedInfo.picture
                  );
                }
              });
            }
          });
          break;
        case "modifyAttribute":
          var { object, attribute, attributeValue } = actionCommand;
          object[attribute] = attributeValue;
          break;
      }

      this.restart();
      this.forceUpdate();
    } else {
      this.setMessage("Nothing to redo");
    }
  }

  setUp() {
    var app = this;
    this.svg = getInitialSVG();
    this.svg.style("background", this.backgroundColor);
    setSVGDefs(this.svg);
    this.svg.on("mousemove", svgOnMouseMove).on("mouseup", svgOnMouseUp);

    function svgOnMouseMove() {
      app.mouseupNode = null;
      if (!app.mousedownNode) return;
      if (d3.event.ctrlKey) {
        app.dragLine
          .classed("hidden", false)
          .style("marker-end", "url(#end-arrow)");

        var transform = d3.zoomTransform(app.container.node());
        var xy1 = transform.invert(d3.mouse(app.svg.node()));
        app.dragLine.attr(
          "d",
          `M${app.mousedownNode.x + app.mousedownNode.width / 2},${
            app.mousedownNode.y + app.mousedownNode.height / 2
          }L${xy1[0]},${xy1[1]}`
        );
      }
    }

    function svgOnMouseUp() {
      // hide drag line
      if (app.mousedownNode)
        app.dragLine.classed("hidden", true).style("marker-end", "");
      if (app.mousedownNode && app.mouseupNode) {
        if (
          app.mousedownNode.type === "text" ||
          app.mouseupNode.type === "text"
        ) {
          // use to need windowclick, now no need for some reason
        }
      }
    }

    var defs = this.svg.append("defs");
    setDefsGradient(defs);

    this.container = this.svg
      .append("svg:g")
      .attr("class", "gContainer")
      .attrs({
        transform: this.previousTransform ? this.previousTransform : null,
      });

    this.dragLine = this.container
      .append("svg:path")
      .attr("class", "link dragline hidden")
      .attr("d", "M0,0L0,0")
      .classed("hidden", true);
    this.path = this.container.append("svg:g").selectAll("path");
    this.rectGroups = this.container.append("svg:g").selectAll("g.nodeGroup");
    this.texts = this.container.append("svg:g").selectAll("g");
    this.circleGroups = this.container.append("svg:g").selectAll("g");
    this.textBox = this.container.append("foreignObject");

    this.drag = getInitialDrag(this);
    this.force = getInitialForce(this);
    var zoom = d3.zoom().on("zoom", function () {
      app.container.attr("transform", d3.event.transform);
    });

    this.svg.call(zoom).on("dblclick.zoom", null);

    this.svg.on("click", windowOnClick);
    d3.select(window).on("keydown", windowOnKeyDown);

    var that = this;
    function windowOnClick() {
      if (d3.event.ctrlKey && !app.mousedownNode) {
        if (!that.state.isTracking || !that.state.isTrackingUI) {
          that.setMessage("Start Tracking to make notes");

          return;
        }
        var rawPoint = d3.mouse(that.svg.node());
        var transform = d3.zoomTransform(that.container.node());

        var point = d3.zoomTransform(transform).invert(rawPoint);

        const node = {
          type: "note",
          id: app.nodes.length,
          width: 150,
          height: 60,
          text: [""],
          x: point[0],
          y: point[1],
          backgroundColor: "#FFFFFF",
          strokeColor: "#000000",
          groupID: null,
          textSize: 15,
          textColor: "#000000",
        };
        app.nodes.push(node);
        var command = {
          action: { type: "addNode", node: node },
          inverse: { type: "delNode", node: node },
        };
        app.storeToHistory(command);
        that.restart();

        var toDispatch = d3
          .selectAll("rect.node")
          .filter(function (d, i, list) {
            return i === list.length - 1;
          });

        toDispatch.dispatch("dblclick");
        that.restart();
      }
      app.mousedownNode = null;
    }
    function windowOnKeyDown() {
      console.log("keydown");
      var app = that;
      if (d3.event.ctrlKey && !app.isTyping) {
        if (
          (d3.event.keyCode === 17 && d3.event.shiftKey) ||
          d3.event.keyCode === 89
        ) {
          app.redo();
        } else if (d3.event.keyCode === 90) {
          app.undo();
        }
      }

      if (!app.selectedNode && !app.selectedLink) return;

      switch (d3.event.keyCode) {
        case 9: //tab
          break;

        case 46: // delete
          if (app.selectedNode && !app.isTyping) {
            var node = app.selectedNode;
            var links = splicelinksForNode(app, app.selectedNode);
            app.nodes = app.nodes.filter((n) => n.id !== app.selectedNode.id);

            var command = {
              action: { type: "delNodeLink", node: node, links: links },
              inverse: { type: "addNodeLink", node: node, links: links },
            };

            app.selectedNode = null;
            app.forceUpdate();

            app.storeToHistory(command);
            app.restart();

            function splicelinksForNode(app, node) {
              const toSplice = app.links.filter(
                (l) => l.source === node || l.target === node
              );
              for (const l of toSplice) {
                app.links.splice(app.links.indexOf(l), 1);
              }

              return toSplice;
            }
          } else if (app.selectedLink) {
            app.links.splice(app.links.indexOf(app.selectedLink), 1);
            var command = {
              action: { type: "delLink", link: app.selectedLink },
              inverse: {
                type: "addLink",
                link: app.selectedLink,
              },
            };

            app.storeToHistory(command);
            app.selectedLink = null;

            app.restart();

            app.forceUpdate();
          }

          break;
      }
    }
    this.restart();
  }

  tick() {
    this.path.attr(
      "d",
      (d) =>
        `M${d.source.x + d.source.width / 2},${
          d.source.y + d.source.height / 2
        }L${d.target.x + d.target.width / 2},${
          d.target.y + d.target.height / 2
        }`
    );

    this.rectGroups.attr("transform", (d) => `translate(${d.x},${d.y})`);

    this.circleGroups.attr("transform", (d) => getTranslateString(d.x, d.y));

    if (this.textBox.attr("x")) {
      this.textBox
        .attr("x", this.selectedNode.x + 25)
        .attr("y", this.selectedNode.y);
    }
  }

  restart() {
    console.log("restarted", this.nodes);

    var app = this;
    var globalRadius = 35;
    var exitDuration = 500;
    this.path = this.path.data(this.links);

    this.path
      .classed("selected", (d) => d === this.selectedLink)
      .style("marker-end", "url(#end-arrow)");

    // EXIT
    var pathExit = this.path.exit();

    pathExit
      .attr("opacity", 1)
      .style("marker-end", null)
      .transition()
      .duration(exitDuration / 2)
      .attr("opacity", 0)
      .on("end", function () {
        d3.select(this).remove();
      });

    this.path = this.path.enter().append("svg:path").merge(this.path);
    this.path
      .attr("class", "link")
      .style("stroke", (d) => d.linkColor)
      .style("marker-end", "url(#end-arrow)")
      .style("stroke-width", "4px");

    this.rectGroups = this.rectGroups.data(
      this.nodes.filter(
        (eachNode) => eachNode.type === "text" || eachNode.type === "note"
      ),
      (d) => d.id
    );

    var rectGroupsExit = this.rectGroups.exit();

    rectGroupsExit
      .attr("background", "red")
      .attr("opacity", 1)
      .transition()
      .duration(exitDuration)
      .attr("opacity", 0)
      .on("end", function () {
        d3.select(this).remove();
      });

    var rectGroupsEnter = this.rectGroups
      .enter()
      .append("svg:g")
      .attr("class", "nodeGroup");

    var rect = rectGroupsEnter.append("svg:rect");

    rect.on("mousedown", textNodeMouseDown).on("mouseup", textNodeMouseUp);

    rect
      .filter((d) => d.type === "note")
      .on("dblclick", textNodeDblClick)
      .on("click", textNodeClick);

    this.circleGroups = this.circleGroups.data(
      this.nodes.filter((eachNode) => eachNode.type === "circle"),
      (d) => d.id
    );

    var circleGroupsEnter = this.circleGroups
      .enter()
      .append("g")
      .attr("class", "circleGroup");
    var clipPaths = circleGroupsEnter
      .append("clipPath")
      .attr("id", function (d, i) {
        //look lke: clipPath0
        return "clipPath" + i;
      })
      .append("circle")
      .attrs({ cx: 75, cy: 20, r: globalRadius - 1 });

    var images = circleGroupsEnter
      .append("svg:image")
      .attr("class", "nodeImage")
      .attrs({
        width: globalRadius * 2 - 1,
        height: globalRadius * 2 - 1,
        x: 40,
        y: -15,
      })
      .attr("clip-path", function (d, i) {
        return "url(#clipPath" + i + ")";
      });
    var circles = circleGroupsEnter
      .append("svg:circle")
      .attrs({
        r: globalRadius,
        cx: 75,
        cy: 20,
        fill: "#FFFFFF",
        class: "node",
      })
      .style("stroke-width", 3);

    images.merge(d3.selectAll(".nodeImage")).each(function (d) {
      if (!d.storedInfo.picture || d3.select(this).attr("href") !== null) {
        // if picture already there or don't have a picture
        return;
      }
      var img = new Image();
      var pictureRef = this;
      img.onload = function () {
        d3.select(pictureRef).attr("href", img.src);
      };
      img.onerror = function () {
        //app.setMessage("Image 404, did you use a proper image address?", 2000);
        d3.select(pictureRef).attr("href", null);
      };
      img.src = d.storedInfo.picture;

      d3.select(this).attr("href", loadingGif);
    });

    var that = this;
    circles
      .merge(d3.selectAll("circle.node"))
      .attr("stroke", function (d, i) {
        return d.strokeColor;
      })
      .attr("fill-opacity", (d) => {
        if (!that.state.isTrackingUI) {
          return d.storedInfo && d.storedInfo.picture ? 0 : 1;
        }

        if (d.isCleared && that.state.isTrackingUI) {
          return d.storedInfo && d.storedInfo.picture !== "" ? 0.7 : 1;
        }

        if (d.storedInfo && d.storedInfo.picture) {
          return 0;
        } else return 1;
      })
      .attr("fill", function (d) {
        console.log(d, that.state.isTrackingUI);

        if (!that.state.isTrackingUI) {
          console.log(d.backgroundColor);
          if (d.backgroundColor) {
            console.log(d.backgroundColor);
            return d.backgroundColor;
          }
        }

        // below is isTracking logic
        if (d.isCleared) {
          return d.storedInfo && d.storedInfo.picture !== ""
            ? "green"
            : "rgb(76, 161, 64)";
        } else {
          return d.backgroundColor;
        }
      });

    var checkMarks = circleGroupsEnter
      .append("svg:image")
      .attr("class", "checkMark");

    checkMarks
      .merge(d3.selectAll(".checkMark"))
      .attrs({
        width: 40,
        height: 40,
        x: 55,
        y: 0,
        opacity: (d) => (d.isCleared && this.state.isTrackingUI ? 1 : 0),
      })
      .attr("clip-path", function (d, i) {
        return "url(#clipPath" + i + ")";
      })
      .attr("href", checkmark);

    this.circleGroups = this.circleGroups.merge(circleGroupsEnter);

    this.circleGroups
      .on("mousedown", textNodeMouseDown)
      .on("mouseup", textNodeMouseUp)
      .on("dblclick", resourceNodeDblClick);

    this.circleGroups.call(this.drag);

    var textContainers = rectGroupsEnter
      .append("svg:g")
      .attr("class", "textContainer");

    textContainers = textContainers
      .merge(d3.selectAll("g.textContainer"))
      .attr("opacity", (d) => d.opacity)
      .attr("dy", function (d) {
        var nwords = d.text.length;
        return "-" + (nwords - 1) * 12;
      });

    // because we are connecting public and note stuff, down up events
    // apply to textContainers

    textContainers
      .on("mousedown", textNodeMouseDown)
      .on("mouseup", textNodeMouseUp);

    textContainers
      .filter((d) => d.type === "note")
      .on("dblclick", textNodeDblClick)
      .on("click", textNodeClick);

    var texts = textContainers.selectAll("text").data((d) => d.text);
    texts.exit().remove();
    texts = texts.enter().append("text").merge(texts);
    texts.html(function (d, i) {
      if (!d) {
        return;
      }
      var a = d;
      while (a.includes(" ")) {
        a = a.replace(" ", "&nbsp;");
      }
      return a;
    });

    var font = this.font;

    textContainers
      .each(function (d, i) {
        d3.select(this)
          .selectAll("text")
          .style("font-family", font)
          .style("font-size", d.textSize + "px")
          .style("fill", d.textColor)
          .attr("y", (_, i) => d.textSize * i + (d.textSize - 12) + "px");

        var eachTextHeight = d3.select(this).select("text").node().getBBox()
          .height;
        var textGroup = d3.select(this).selectAll("text");
        var widthArray = [],
          heightArray = [];
        textGroup.each(function () {
          heightArray.push(d3.select(this).node().getBBox().height);
          widthArray.push(d3.select(this).node().getBBox().width);
        });
        d.width = Math.max(...widthArray) + 50;
        d.height =
          d.text.length === 1 && d.text[0] === ""
            ? d.text.length * (d.textSize + 5) + d.textSize + 15
            : d.text.length * Math.max(...heightArray) + d.textSize + 15;
      })
      .style("transform", function (d) {
        var bboxWidth = d3.select(this).node().getBBox().width;

        var bboxHeight = d3.select(this).node().getBBox().height;
        var toShiftX = 25;
        var toShiftY = (d.height - bboxHeight) / 2 + 12.5;
        return "translate(" + toShiftX + "px, " + toShiftY + "px)";
      });

    rect
      .merge(d3.selectAll("rect.node"))
      .attrs({
        class: "node",
        rx: 6,
        ry: 6,
        width: (d) => d.width + "px",
        height: (d) => d.height + "px",
        fill: "#FFFFFF",
      })
      .style("stroke-width", 2)
      .attr("stroke", function (d) {
        if (app.selectedNode && d.id === app.selectedNode.id) {
          return "url(#svgGradient)";
        }
        return d.strokeColor;
      })
      .attr("fill", (d) => d.backgroundColor);

    this.rectGroups = this.rectGroups.merge(rectGroupsEnter);
    this.rectGroups.call(this.drag);

    this.force.nodes(this.nodes);
    this.force.force(
      "link",
      d3
        .forceLink(this.links)
        .id((d) => d.id)
        .distance(function (d) {
          return d.linkDistance;
        })
    );

    this.force.alphaTarget(0.3).restart();

    var that = this;
    function resourceNodeDblClick(nodeData) {
      if (!that.state.isClearMode) {
        return;
      }

      // TODO: MONGODB UPDATE HERE TOO:
      nodeData.isCleared = !nodeData.isCleared;
      var path = that.props.history.location.pathname;
      var roadmapID = path.substring(path.indexOf("/roadmap/") + 9);
      updateClearItem({
        roadmapId: roadmapID,
        nodeId: nodeData.id,
        updateMode: nodeData.isCleared ? "push" : "pull",
      })
        .then((uh) => console.log(uh))
        .catch((err) => console.log(err));

      that.restart();
    }

    function textNodeDblClick(noteData) {
      that.selectedNode = noteData;
      that.mousedownNode = null;
      that.startText = noteData.text;
      that.textBox = that.textBox
        .attr("x", noteData.x)
        .attr("y", noteData.y)
        .attr("width", "500%")
        .attr("height", "100vh");

      that.nodes.map((eachNode) => {
        if (eachNode.id === that.selectedNode.id) {
          console.log("change this");
          eachNode.opacity = 0;
          that.restart();
        }
      });

      var paragraph = that.textBox
        .append("xhtml:textarea")
        .attr("id", "textBoxP")
        .html(() => {
          var stringBuilder = "";
          for (var i = 0; i < noteData.text.length; i++) {
            stringBuilder += noteData.text[i];
            if (noteData.text.length > 1) {
              stringBuilder += "\n";
            }
          }

          console.log({ stringBuilder });
          return stringBuilder;
        })
        .attr("spellcheck", false)
        .style("height", "300vh")
        .style("width", "5000%")
        .style("outline", "none")
        .style("font", noteData.textSize + "px " + noteData.textFont)
        .style("font-family", that.font)
        .style("line-height", noteData.textSize + "px")
        .style("display", "block")
        .style("border", "none")
        .style("resize", "none")
        .style("overflow", "auto")
        .style("background", "none")
        .attr("maxlength", 2000);

      paragraph
        .on("blur", function () {
          var zoom = d3.zoom().on("zoom", function () {
            that.container.attr("transform", d3.event.transform);
          });

          that.svg.call(zoom).on("dblclick.zoom", null);

          d3.selectAll("foreignObject").remove();
          that.textBox = that.container.append("foreignObject");
          that.resourceForm = that.container
            .append("foreignObject")
            .attr("id", "resourceForm");
          that.nodes.map((eachNode) => {
            eachNode.opacity = 1;
          });
          that.restart();

          //TODO: if text isn't the same or the node is brand new, store to history
          //on add new node, notNewNode is false
          //on dblclick, blur, notNewNode is true
          if (that.startText !== noteData.text) {
            that.nodeToChange = noteData;
            var command = {
              action: {
                type: "modifyText",
                node: that.nodeToChange,
                text: noteData.text,
              },
              inverse: {
                type: "modifyText",
                node: that.nodeToChange,
                text: that.startText,
              },
            };
            that.storeToHistory(command);
          }

          that.startText = null;
          that.nodeToChange = null;
          that.isTyping = false;
          that.textInputCircle = null;
        })
        .on("keydown", function () {
          if (d3.event.keyCode === 13 && !d3.event.shiftKey) {
            d3.event.preventDefault();
          }

          if (
            d3.event.keyCode === 13 &&
            d3.event.shiftKey &&
            noteData.text.length === 1 &&
            noteData.text[0] === ""
          ) {
            d3.event.preventDefault();
            that.setMessage(
              "Please write something before starting a new line",
              2000
            );
            return;
          } else {
          }
        })
        .on("keyup", function () {
          if (d3.event.keyCode === 13 && !d3.event.shiftKey) {
            this.blur();
          } else if (d3.select(this).node().value.length > 1999) {
            that.setMessage(
              "This textbox has reached the 2000 character limit",
              1000
            );

            that.restart();
          } else {
            var node = d3.select(this).node();
            // note, d.text is referring to the d in dblclick, d in g, d in text, from that.nodes
            var nodeHTML = d3.select(this).node().value;

            /*

              nodeHTML = nodeHTML.slice(3, nodeHTML.length - 4);

              if (
                nodeHTML.substring(nodeHTML.length - 4, nodeHTML.length) === "<br>"
              ) {
                nodeHTML = nodeHTML.slice(0, nodeHTML.length - 4);
              }
      */
            var textArr = nodeHTML.split("\n");
            console.log(nodeHTML === "\n");
            console.log({ textArr });
            noteData.text = textArr;
            that.restart();
          }
        })
        .on("keypress", function () {})
        .on("paste", function () {
          if (d3.select(this).node().value.length > 1999) {
            that.setMessage(
              "This textbox has reached the 2000 character limit",
              1000
            );
            that.restart();
          }
          /*
            function insertTextAtCursor(text) {
              var sel, range, html;
              if (window.getSelection) {
                sel = window.getSelection();
                if (sel.getRangeAt && sel.rangeCount) {
                  range = sel.getRangeAt(0);
                  range.deleteContents();
                  range.insertNode(document.createTextNode(text));
                }
              } else if (document.selection && document.selection.createRange) {
                document.selection.createRange().text = text;
              }
            }
      */
        });

      paragraph.node().focus();
    }
    function textNodeClick(noteData) {
      if (!that.state.isTracking || !that.state.isTrackingUI) {
        return;
      }

      that.selectedLink = null;
      if (noteData === that.selectedNode) {
        that.selectedNode = null;
        that.forceUpdate();
        that.restart();
      } else {
        that.selectedNode = noteData;
        that.restart();
        that.forceUpdate();
      }
    }

    function textNodeMouseDown(noteData) {
      if (!that.state.isTracking || !that.state.isTrackingUI) {
        return;
      }
      that.mousedownNode = noteData;
      console.log("mousedown");
    }

    function textNodeMouseUp(noteData) {
      console.log("mouseup");
      var app = that;
      var mousedownNode = app.mousedownNode,
        selectedNode = app.selectedNode;

      // needed by FF
      app.dragLine.classed("hidden", true).style("marker-end", "");

      app.mouseupNode = noteData;
      if (app.mouseupNode === app.mousedownNode) {
        app.mousedownNode = null;
        app.selectedNode = null;
        app.forceUpdate();
        return;
      }

      if (!that.state.isTracking || !that.state.isTrackingUI) {
        return;
      }

      if (mousedownNode.type !== "note" && app.mouseupNode.type !== "note") {
        that.setMessage("at least one connector subject must be your note");
        return;
      }

      const source = app.mousedownNode;
      const target = app.mouseupNode;
      var link = {
        source: source,
        target: target,
        linkDistance: 250,
        index: app.links.length,
      };
      app.links.push(link);
      var command = {
        action: { type: "addLink", link: link },
        inverse: { type: "delLink", link: link },
      };

      app.storeToHistory(command);
      app.restart();
    }
  }

  setMessage = (message) => {
    var app = this;
    this.setState(
      { errorMessages: [...this.state.errorMessages, message] },
      () => {
        var div = d3
          .select(".errorMessageContainer")
          .append("div")
          .lower()
          .attr("class", "errorMessage")
          .html(message);

        div.append("xhtml:i").attr("class", "fa fa-ban");

        div.style("opacity", 0).transition().duration(750).style("opacity", 1);

        setTimeout(function () {
          div
            .transition()
            .duration(750)
            .style("opacity", 0)
            .on("end", () => {
              var noLastEle = app.state.errorMessages.splice(
                0,
                app.state.errorMessages.length - 1
              );
              app.setState({ errorMessages: noLastEle }, () => {});

              div.remove();
            });
        }, 3000);
      }
    );
  };

  handleTracking = (toggleModal) => {
    //case 1: if user is not logged in, toggle modal
    //case 2: if user logged in, already tracking, pressing will prompt are you sure?
    //case 3: user is logged in, make it track, open it in track view

    if (!this.state.creatorData) {
      return;
    }

    if (!this.context.isLoggedIn) {
      this.props.history.push("/");
      toggleModal();
      return;
    }

    this.setState({ isTrackRequestReceived: false });

    // we are logged in at this point
    if (this.state.isTracking) {
      if (!window.confirm("Are you sure? You will lose all of your notes")) {
        this.setState({ isTrackRequestReceived: true });
        return;
      }

      // roadmapId is
      var path = this.props.history.location.pathname;
      var roadmapID = path.substring(path.indexOf("/roadmap/") + 9);
      var toPullRoadmapId = new Realm.BSON.ObjectId(roadmapID);

      this.setState({ isTracking: false, isTrackingUI: false });

      onUntrackRoadmap(toPullRoadmapId)
        .then((newDoc) => {
          // update UI, change to publicView
          /*    const publicViewUIWrapper = this.publicViewUIWrapperRef.current;
          publicViewUIWrapper.classList.toggle("is-visible");
          const trackViewUIWrapperRef = this.trackViewUIWrapperRef.current;
          trackViewUIWrapperRef.classList.toggle("is-visible");
*/
          this.setState({
            isTrackRequestReceived: true,
          });
        })
        .catch((err) => {
          this.setState({ isTrackRequestReceived: true });
          alert(err);
        });
    } else {
      //subscribe the roadmap

      var path = this.props.history.location.pathname;
      var roadmapID = path.substring(path.indexOf("/roadmap/") + 9);
      var roadmapDataHistory = this.roadmapMacroData.roadmapDataHistory;
      var newTrackRoadmap = {
        creatorId: this.state.creatorData.userId,
        roadmapId: new Realm.BSON.ObjectId(roadmapID),
        noteNodes: [],
        noteLinks: [],
        completedNodesID: [],
        editionIndex: roadmapDataHistory.length - 1,
        totalNodeCount:
          roadmapDataHistory[roadmapDataHistory.length - 1].totalNodeCount,
        resourceNodeCount:
          roadmapDataHistory[roadmapDataHistory.length - 1].resourceNodeCount,
      };

      onTrackRoadmap(newTrackRoadmap)
        .then((newUser) => {
          /*    const publicViewUIWrapper = this.publicViewUIWrapperRef.current;
          publicViewUIWrapper.classList.toggle("is-visible");
          const trackViewUIWrapperRef = this.trackViewUIWrapperRef.current;
          trackViewUIWrapperRef.classList.toggle("is-visible"); */
          this.setState({
            isTracking: true,
            isTrackRequestReceived: true,
            isTrackingUI: true,
            editionIndex: this.roadmapMacroData.roadmapDataHistory.length - 1,
          });
          // TODO: animate from roadmapView to trackView
        })
        .catch((err) => {
          this.setState({ isTrackRequestReceived: true });
          alert(err);
        });
    }
  };

  toggleTrack = () => {
    const publicViewUIWrapper = this.publicViewUIWrapperRef.current;
    publicViewUIWrapper.classList.toggle("is-visible");
    const trackViewUIWrapperRef = this.trackViewUIWrapperRef.current;
    trackViewUIWrapperRef.classList.toggle("is-visible");
    if (this.state.isTrackingUI) {
      // swapping to public
      this.setState({ isTrackingUI: !this.state.isTrackingUI }, () => {
        this.trackNodes = [...this.nodes];
        this.trackLinks = [...this.links];
        this.nodes = [...this.publicNodes];
        this.links = [...this.publicLinks];

        console.log(this.nodes);
        this.restart();
      });
    } else {
      // coming back to public
      this.setState(
        {
          isTrackingUI: !this.state.isTrackingUI,
          isClearMode: false,
        },
        () => {
          this.nodes = [...this.trackNodes];
          this.links = [...this.trackLinks];
          this.restart();
        }
      );
    }
  };

  toggleClear = () => {
    this.setState({ isClearMode: !this.state.isClearMode });
  };

  toggleViewTextButton = () => {
    var globalRadius = 35;
    var font = this.font;
    if (this.state.shouldViewText) {
      d3.selectAll("g.circleGroup").selectAll("foreignObject").remove();
    } else {
      d3.selectAll("g.circleGroup").each(function (d, i) {
        var { url, info, title } = d.storedInfo;
        url = url.trim();
        info = info.trim();
        title = title.trim();
        var textCardContainer = d3
          .select(this)
          .append("foreignObject")
          .style("max-width", "200px")
          .attrs({
            x: "-65px",
            y: "20px",
            width: "280px",
            height: url || info || title ? "1000px" : "0px",
          });

        if (url || info || title) {
          var textCard = textCardContainer
            .append("xhtml:div")
            .attrs({ class: "speechBubbleDiv" })
            .style("font-family", font);

          var triangle = textCardContainer
            .append("xhtml:div")
            .attrs({ class: "triangleDiv" });
        }
        if (d.storedInfo.title)
          var textTitle = textCard
            .append("xhtml:p")
            .attr("class", "previewCardTitle")
            .html(d.storedInfo.title);

        if (d.storedInfo.info)
          var textInfo = textCard
            .append("xhtml:p")
            .attr("class", "previewCardDescription")
            .html(d.storedInfo.info);

        if (d.storedInfo.url) {
          var span = textCard
            .append("xhtml:a")
            .attr("class", "description url")
            .html((d) => "Go to resource")
            .attr("href", d.storedInfo.url)
            .attr("target", "_blank");

          span.append("xhtml:i").attr("class", "fas fa-globe");
        }

        if (url || title || info) {
          var ay = d3.select(".gContainer").attr("transform");

          var scaleToMultiplyBy;
          if (!ay) {
            scaleToMultiplyBy = 1;
          } else if (ay.indexOf("scale(") === -1) {
            scaleToMultiplyBy = 1;
          } else {
            scaleToMultiplyBy = ay.substring(
              ay.indexOf("scale(") + 6,
              ay.lastIndexOf(")")
            );
          }

          var bound = textCard.node().getBoundingClientRect();

          textCardContainer.attrs({
            height: (bound.height * 1) / scaleToMultiplyBy + 10 + "px",
          });
        }
      });
    }

    this.setState({ shouldViewText: !this.state.shouldViewText });
    // for each cirlcegroup
  };

  render() {
    // if we are initially trakcing & currently tracking, show "show public mode"
    // if we are not initially tracking & current tracking, show "show public mode"
    // if we are not currently tracking

    console.log(this.context);
    if (this.state.isRoadmapLoading) {
      return <div>loading...</div>;
    }

    let message;
    console.log(this.state.isTracking, this.state.isTrackingUI);
    if (!this.state.isTracking) {
      message = null;
    } else if (this.state.isTracking && this.state.isTrackingUI) {
      message = (
        <div>
          View original Roadmap{" "}
          {this.state.editionIndex !== this.state.lastestIndex && (
            <div>Updatable!</div>
          )}
        </div>
      );
    } else message = "Go back to Track Mode";

    let saveMessage;
    if (!this.state.hasNewNoteSavingRequested) {
      saveMessage = null;
    } else if (this.state.isNewNoteSaving) {
      saveMessage = "Saving";
    } else {
      saveMessage = "Saved";
    }

    return (
      <React.Fragment>
        <Navbar />
        <div id="editorsContainer">
          {saveMessage}
          <div className="GraphEditorContainer">
            {message ? (
              <React.Fragment>
                <div
                  onClick={this.toggleTrack}
                  ref={this.trackViewUIWrapperRef}
                  className="modeSwitchContainer"
                >
                  {message}
                </div>
              </React.Fragment>
            ) : null}

            <div
              className="toggleAllTextsButtonWrapper"
              onClick={this.toggleViewTextButton}
              style={{ top: "25%" }}
            >
              <a className="fancy-button pop-onhover bg-gradient1">
                {this.state.shouldViewText ? (
                  <span className="toggleAllTextButton">
                    Hide All Resource Node Texts
                  </span>
                ) : (
                  <span className="toggleAllTextButton">
                    View All Resource Node Texts
                  </span>
                )}
              </a>
            </div>

            {this.state.isTracking && this.state.isTrackingUI ? (
              <div
                onClick={this.toggleClear}
                className="modeSwitchContainer clear"
              >
                {this.state.isClearMode
                  ? "Turn off clear mode"
                  : "Turn on clear mode"}
              </div>
            ) : null}

            <div
              className={
                this.state.isTrackingUI
                  ? "CreatorCardContainer"
                  : "CreatorCardContainer is-visible"
              }
              ref={this.publicViewUIWrapperRef}
            >
              <div className="CreatorCardTitle">
                {this.title || <Skeleton />}
              </div>
              <div className="big">
                {this.state.creatorData ? (
                  <img
                    className="CreatorCardProfilePic"
                    src={this.state.creatorData.profilePic}
                  />
                ) : (
                  <Skeleton width={50} height={50} circle={true} />
                )}

                <div className="small">
                  <span className="text">
                    {this.state.creatorData ? (
                      this.state.creatorData.userName
                    ) : (
                      <Skeleton />
                    )}
                  </span>
                  <span className="date">{this.date || <Skeleton />}</span>
                </div>
              </div>

              {this.state.isTrackRequestReceived ? (
                <ModalContext.Consumer>
                  {({ isModalShowing, toggleModal }) => (
                    <span
                      className="button"
                      onClick={() => {
                        this.handleTracking(toggleModal);
                      }}
                    >
                      {this.state.isTracking ? "Untrack" : "Start Tracking"}
                    </span>
                  )}
                </ModalContext.Consumer>
              ) : (
                <span className="button">
                  {this.state.isTracking ? "Untracking" : "Tracking"}
                </span>
              )}
            </div>
          </div>
          {this.state.errorMessages.length > 0 ? (
            <div className="errorMessageContainer"></div>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

RoadmapReader.contextType = StitchAuthContext;
export default RoadmapReader;
